<section class="nearby-section" #nearbySection>
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">Workshops Near You</h2>
      <p class="section-subtitle">Intensive workshops and masterclasses in your area</p>
    </div>

    @if (loading) {
      <div class="loading-state">
        <div class="loading-spinner"></div>
        <p>Loading nearby workshops...</p>
      </div>
    }

    @if (error) {
      <div class="error-state">
        <p>{{ error }}</p>
        <button type="button" (click)="loadWorkshops(location)" class="retry-btn">Try Again</button>
      </div>
    }

    @if (!loading && !error) {
      @if (workshops.length === 0) {
        <div class="empty-state">
          <p>No workshops found near your location. Try increasing your search radius.</p>
        </div>
      } @else {
        <div class="events-grid">
          @for (workshop of workshops; track workshop.id) {
            <a [routerLink]="['/events', workshop.id]" class="event-card">
              <div class="event-image">
                <img [src]="workshop.imageUrl || placeholderImage" [alt]="workshop.name" [title]="workshop.name">
                <div class="event-type">Workshop</div>
              </div>
              <div class="event-content">
                <h3 class="event-title">{{ workshop.name }}</h3>
                @if (workshop.levels && workshop.levels.length) {
                  <div class="level-badges">
                    @for (level of workshop.levels; track level) {
                      <span class="level-badge">{{ level }}</span>
                    }
                  </div>
                }
                <div class="event-details">
                  <div class="event-location">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>{{ workshop.locationName || workshop.studio.name || workshop.city }}</span>
                  </div>
                  <div class="event-date">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span>{{ formatDate(workshop.startTime) }}</span>
                  </div>
                </div>
                <div class="event-footer">
                  <span class="event-price">{{ formatPriceRange(workshop.priceTiers) }}</span>
                  <span class="view-btn">View Details</span>
                </div>
              </div>
            </a>
          }
        </div>

        <div class="view-more-wrap">
          <a
            routerLink="/events"
            [queryParams]="viewMoreParams"
            class="view-more-btn"
          >View More Workshops</a>
        </div>
      }
    }
  </div>
</section>
